module.exports = __webpack_public_path__ + "img/resultTwo_web.33a1b462.jpg";